export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ22.244053ab.mp3";